Ext.define('SA.AttributesQueryBuilder', {
    statics: {
        create() {
            return new SA.AttributesQueryBuilder();
        },

        select(field) {
            return this.create().field(field);
        },

        valueOf(field) {
            return this.select(field).limit(1);
        }
    },

    constructor() {
        this.cfg = {type: 'attributes'};
        this.wherePredicates = [];
    },

    censusRelease(censusRelease) {
        this.where('country', censusRelease.country);
        this.where('censusRelease', censusRelease.censusRelease);
        return this;
    },

    field(field) {
        return this.fields([field]);
    },

    fields(fields) {
        this.cfg.fields = fields;
        return this;
    },

    forAttribute(attribute) {
        return this.where('attribute', attribute);
    },

    group(group) {
        return this.where('group', group);
    },

    limit(limit) {
        this.cfg.limit = limit;
        return this;
    },

    name(name) {
        return this.where('name', name);
    },

    run() {
        var where = ['and', ...this.wherePredicates],
            query = SA.data.Query.from({...this.cfg, where}),
            requestedSingleRow = this.cfg.limit === 1,
            requestedSingleField = this.cfg.fields.length === 1;

        return query.run()
            .then(({hits: rows}) => {
                if (requestedSingleField) {
                    rows = rows.map(row => row[0]);
                }
                else {
                    rows = rows.map(row => SA.Object.fromKeyValueArrays(this.cfg.fields, row));
                }

                return requestedSingleRow ? rows[0] : rows;
            });
    },

    statusVisible() {
        return this.where('status', 'visible');
    },

    type(type) {
        return this.where('type', type);
    },

    where(field, value) {
        this.wherePredicates.push(['=', field, value]);
        return this;
    },

    year(year) {
        return this.where('year', year);
    }
});